import React from 'react';
import styled from 'styled-components';
import { ImpactClaimTitle } from 'components/Shared/ImpactClaims';
import { Check2Circle } from '@styled-icons/bootstrap/Check2Circle';
import { Tooltip } from 'components/Shared';
import { useTranslation } from 'react-i18next';
const Container = styled.div `
  width: 100%;
  margin-bottom: 8px;
`;
const HorizontalContainer = styled.div `
  overflow: auto;
  width: 100%;
  padding-left: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;
const SeedtraceLogo = styled.img `
  height: 14px;
`;
const VerifiedWrapper = styled.div `
  display: flex;
  align-items: center;
  margin: 20px 16px 16px;
`;
const VerifiedTitle = styled.h6 `
  font-size: 14px;
  font-weight: 300;
  margin: 0 6px;
  white-space: nowrap;
`;
const TooltipContainer = styled.div `
  width: fit-content;
`;
const ClaimRow = styled.div `
  display: flex;
`;
const ImpactClaimsCarousel = ({ impactClaims, toggleImpactClaim, }) => {
    const { t } = useTranslation();
    // impact claims array is divided into two so that 2 rows can be displayed
    const middle = Math.ceil(impactClaims.edges.length / 2);
    const firstClaimRow = impactClaims.edges.slice(0, middle);
    const secondClaimRow = impactClaims.edges.slice(middle);
    return (React.createElement(Container, null,
        React.createElement(TooltipContainer, null,
            React.createElement(Tooltip, { tooltipText: t('impact-claims.subtitle') },
                React.createElement(VerifiedWrapper, null,
                    React.createElement(Check2Circle, { size: 16 }),
                    React.createElement(VerifiedTitle, null, t('impact-claims.verified-with')),
                    React.createElement(SeedtraceLogo, { src: "/seedtrace_logo_wordmark_black.svg", alt: "seedtrace_logo" })))),
        React.createElement(HorizontalContainer, null,
            React.createElement(ClaimRow, null, firstClaimRow.map((impactClaim) => (React.createElement(ImpactClaimTitle, { key: impactClaim.node.id, impactClaim: impactClaim.node, onClaimClick: toggleImpactClaim })))),
            React.createElement(ClaimRow, null, secondClaimRow.map((impactClaim) => (React.createElement(ImpactClaimTitle, { key: impactClaim.node.id, impactClaim: impactClaim.node, onClaimClick: toggleImpactClaim })))))));
};
export default ImpactClaimsCarousel;
